import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subject, combineLatest, distinctUntilChanged, takeUntil } from 'rxjs';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { AccountFacade } from 'ish-core/facades/account.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsFacade } from '../../../facades/dot-cms.facade';

// This is customized component for ICSA
@Component({
  selector: 'custom-dot-cms-category-list-manual',
  templateUrl: './dot-cms-category-list-manual.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsCategoryListManualComponent implements DotCmsContentTypeComponent, OnDestroy, OnInit {
  identifier: string;
  contentlet: CustomDotCmsContentlet;
  private destroy$ = new Subject<void>();
  categoryUniqueIds: string[];
  fetchedCategories$ = new ReplaySubject<CategoryView[]>(1);
  categoriesFetched: CategoryView[];

  constructor(
    private shoppingFacade: ShoppingFacade,
    private accountFacade: AccountFacade,
    private dotCmsFacade: DotCmsFacade
  ) {}

  ngOnInit() {
    combineLatest([
      this.dotCmsFacade.getContentletByIdentifier$(this.identifier),
      this.accountFacade.isLoggedIn$.pipe(takeUntil(this.destroy$)),
    ]).subscribe(([contentlet, _]) => {
      this.contentlet = contentlet;
      this.categoryUniqueIds = this.contentlet.allCategories.split(',');
      this.getCategories(this.categoryUniqueIds);
    });
  }

  //Todo: Code refactor required
  getCategories(categoryUniqueIds: string[]) {
    let categories: Map<string, CategoryView> = new Map();
    categoryUniqueIds.forEach(uniqueId => {
      this.shoppingFacade
        .getSingleCategoryByUniqueId$(uniqueId)
        .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
        .subscribe(category => {
          categories.set(uniqueId, category);
          this.categoriesFetched = [];
          categories.forEach(category => {
            this.categoriesFetched.push(category);
          });
          this.categoriesFetched = this.categoriesFetched.filter(category => category !== undefined);

          if (categories.size === categoryUniqueIds.length && this.categoriesFetched.length > 0) {
            this.fetchedCategories$.next(this.categoriesFetched);
          }
        });
    });
  }

  getContentlet(identifier: string) {
    return this.dotCmsFacade.getContentletByIdentifier$(identifier);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
